import getUrl from 'airship/modules/get-url'
import createRequest from 'airship/modules/typesafe-request'
import {Details} from 'airship/components/InProductSupport/detailsSlice'
import {resolveCreateTicketResponse, CreateTicketResponse} from './types'

const CREATE_TICKET_URL = 'in_product_support:create_ticket'

export async function createTicket(
  details: Details
): Promise<CreateTicketResponse> {
  const path = getUrl(CREATE_TICKET_URL)
  const request = createRequest({path})
  const result = await request.post(resolveCreateTicketResponse, {
    body: details,
  })
  return result.body
}
